import { getQueryParam } from '@crehana/utils';

const getEmailParam = () => getQueryParam('email_user') || '';

export default getEmailParam;
